// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"image"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 21H20L9 10L3 16V21Z"}},{"tag":"circle","attrs":{"id":"fill2","cx":15.75,"cy":8.25,"r":2,"fill":"props.fillColor2"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 16V3H21V21H20M3 16V21H20M3 16L9 10L20 21","strokeWidth":"props.strokeWidth"}},{"tag":"circle","attrs":{"id":"stroke2","cx":15.75,"cy":8.25,"r":2,"stroke":"props.strokeColor2","strokeWidth":"props.strokeWidth"}}]}]};

const ImageIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'image',
    ref,
    icon: element,
  },
));

ImageIcon.displayName = 'ImageIcon';

export default ImageIcon;
